import { z } from 'zod';

// Must match Contentful space role names exactly.
export const UserRoleEnum = z.enum(['Editor', 'Author', 'Tester']);
export type UserRoleEnum = z.infer<typeof UserRoleEnum>;
